<template>
    <div style="height: 100%">
        <LeftNavBar
            :title="selectedAppInitial"
            :hasChild="false"
            :items="sidebarItems"
            @opened="filterType"
            :selectedValue="published ? 'published' : 'projects'"
        />
    </div>
</template>

<script>
import LeftNavBar from "bh-mod/components/common/LeftNavBar";
export default {
    components: { LeftNavBar },
    name: "menu-left",
    data() {
        return {
            openID: "",
        };
    },
    computed: {
		selectedAppInitial() {
            return (
                (this.$store.state.theApp &&
                    this.$store.state.theApp.media &&
                    this.$store.state.theApp.media.initial) ||
                "TB"
            );
        },
        sidebarItems() {
            let items = [
                {
                    label: "All Projects",
                    value: "projects",
					iconUrl: require("@/assets/sideIcons/projects.svg"),
                    loading: false,
                    options: [],
                    children: [],
                },
                {
                    label: "Published",
                    value: "published",
                    iconUrl: require("@/assets/sideIcons/published.svg"),
                    loading: false,
                    options: [],
                    children: [],
                }
            ];
            return items;
        },
        forms() {
            return Object.values(this.$store.state.forms.allForms);
        },
        lots() {
            return this.$store.state.forms.lots;
        },
        folders() {
            return this.$store.getters.folders;
        },
        files() {
            return this.$store.getters.allFiles;
        },
        published() {
            return this.$store.state.appData.filterPublished;
        },
    },
    methods: {
        filterType(data) {
            let path = this.$route.path;

            if (path !== "/") this.$router.push("/");
            this.$store.commit("SET_PROP", {
                where: ["filterPublished"],
                what: data.value === "published",
            });
        },
        handleClick(e) {
            this.$store.commit("changeFolder", e.key);
        },
    },
};
</script>
